import type {
  AccommodationStatusResponseDto,
  PlacementDetailsWorkRestriction,
} from 'src/store/placementDetailsPageSlice/types';

export enum UpdateStatusProgress {
  StatusSelection,
  DecisionByLoginEntry,
  DlsReferralFormEntry,
}

/**
 * The placement data the update menu and its modals operate on, built by both the placement details
 * page (Redux) and the associate profile page (TanStack). `statusOptions` is the site catalog on the
 * non-DH path and the per-accommodation next statuses on the DH path.
 */
export interface PlacementInfo {
  placementId: string;
  regionId: number;
  accommodationType: string;
  placementStatus: string;
  externalCaseId: string;
  managerAlias: string;
  fc: string;
  countryId: number;
  associateName: string;
  modifiedShiftLength: number;
  workRestrictions: PlacementDetailsWorkRestriction[];
  statusOptions: AccommodationStatusResponseDto[];
  isSiteParticipatingInDecisionHubPilot: boolean;
}

/**
 * Everything the update-status flow needs, supplied by the caller so the modal works on both the
 * Redux-driven placement details page and the TanStack-driven associate profile. `onSuccess` runs
 * after a successful update (refetch/invalidate); `onClose` dismisses the modal.
 */
export interface UpdateStatusContext {
  placement: PlacementInfo;
  onSuccess: () => void;
  onClose: () => void;
}
